import React from "react";

function Color_Values() {
  return (
    <div>
      <h1>Color_Values Component</h1>
      <p>This is the Color Values tutorial page content.</p>
    </div>
  );
}

export default Color_Values;
